<template>
  <div
    id="app"
    :class="[isImmerse && 'has-top']"
    :style="{
      opacity: !pageLoading ? 1 : 0,
      background: thisPage == 'blank' ? '#fff' : '',
    }"
  >
    <!-- 顶部分享按钮 -->

    <div class="top" v-if="isImmerse" :style="{ top: statusBarHeight + 'px' }">
      <button class="back-btn" @click="back"></button>
      <button class="share-btn" @click="share"></button>
    </div>

    <!--            <div class="music" :style="{'top': statusBarHeight+'px'}">-->
    <!--                <button class="music-btn" :class="!musicFlag && 'off'" @touchstart="switchMusic"></button>-->
    <!--                <audio id="music" autoplay :data-play="musicFlag" loop="loop" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du49c1ptuc41eq11ji68rcjge9.mp3"></audio>-->
    <!--            </div>-->
    <!--            <base-component :baseData="baseData" v-if="baseData"></base-component>-->

    <div>
      <transition
        enter-active-class="animated fadeInUpBig"
        leave-active-class="animated fadeOutDownBig "
      >
        <div class="detailPop" v-show="isToastShow" id="detailPop">
          <div
            :class="[
              toastContent.toastType == 11 || toastContent.toastType == 12
                ? 'popWrapper2'
                : 'popWrapper',
            ]"
          >
            <div
              class="contentPopCls"
              :style="[
                toastContent.closeColor === 'white' ? { padding: 0 } : {},
              ]"
            >
              <div class="topsOperate">
                <div class="popName">{{ toastContent.list.name }}</div>
                <div class="close" @click="onCloseToast">
                  <img
                    src="./assets/img/close.png"
                    alt="关闭"
                    class="closeImg"
                    v-if="
                      !toastContent.closeColor ||
                        toastContent.closeColor === 'black'
                    "
                  />
                  <img
                    src="./assets/img/closeWhite.png"
                    alt="关闭"
                    class="closeImg"
                    v-else
                  />
                </div>
              </div>
              <div
                :class="[
                  !toastContent.closeColor ||
                  toastContent.closeColor === 'black' ||
                  toastContent.toastType === 9 ||
                  toastContent.toastType === 10
                    ? 'contentTips'
                    : 'contentTips2',
                ]"
                id="contentTips"
                ref="contentTips"
                @scroll="handleScroll(toastContent.toastType)"
              >
                <div class="content" ref="content" v-if="isToastShow">
                  <div
                    class="popGlobalText"
                    v-html="toastContent.list.content"
                    v-if="toastContent.toastType == 0"
                  >
                    {{ toastContent.list.content }}
                  </div>
                  <SelectButton
                    v-if="toastContent.toastType == 1"
                    :list="tourSelectData"
                    @on-select="oTourSelect"
                  />
                  <ScenicSpot
                    v-if="toastContent.toastType == 2"
                    :list="tourSelectData"
                    @on-select="oTourSelect"
                  />
                  <NearbyPoint
                    v-if="toastContent.toastType == 5"
                    :list="toastContent.list.content"
                    point-type="food"
                  />
                  <NearbyPoint
                    v-if="toastContent.toastType == 6"
                    :list="toastContent.list.content"
                    point-type="scenery"
                  />
                  <NewsInfo v-if="toastContent.toastType == 7" />
                  <NewsInfo v-if="toastContent.toastType == 8" />

                  <AudioInfo
                    v-if="toastContent.toastType == 9"
                    :list="toastContent.list.content"
                    :refresh="isShouldRefresh"
                  />
                  <XimalayaAudioInfo
                    v-if="toastContent.toastType == 10"
                    :list="toastContent.list.content"
                    :refresh="isShouldRefresh"
                  />

                  <ToastInfo
                    v-if="toastContent.toastType == 11"
                    :list="toastContent.list.content"
                    type="activity"
                  />
                  <ToastInfo
                    v-if="toastContent.toastType == 12"
                    :list="toastContent.list.content"
                    type="movie"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="isUserShow" class="scrollUser">
      <ScrollUser :list="fakeUserList" />
      <div class="topMask"></div>
      <div class="bottomMask"></div>
    </div>

    <div
      class="maskWarp"
      :style="`display:${maskShowStatus ? 'block' : 'none'}`"
    ></div>
  <!-- 提示框，不带操作按钮 -->
    <div class="loadMask" v-if="!!maskData">
      <div :class="maskData.type===11?'maskContent SmallmaskContent':'maskContent'">
        <p v-html="(maskData.text && maskData.text) || '加载中...'"></p>
        <div class="btn_wrapper" v-if="maskData.type===11">
          <div class="cancel" @click="onCancel">取消</div>
          <div class="ok" @click="goSet">确认</div>
        </div>
      </div>
    </div>
  


    <keep-alive :include="cacheList">
      <router-view :style="{ 'padding-top': statusBarHeight + 'px' }" />
    </keep-alive>
  </div>
</template>

<script>
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import { getmicrophone } from "@/utils/utils";
import SelectButton from "@/components/Use/selectButton";
import ScenicSpot from "@/components/Use/scenic-spot";
import NearbyPoint from "@/components/Use/nearby-point";
import NewsInfo from "@/components/Use/news-info";
import AudioInfo from "@/components/Use/audio-info";
import XimalayaAudioInfo from "@/components/Use/ximalaya-audio-info";
import { getAudioAccess } from "@/utils/AudioSDK.js";
import { config, XMLY, XMplayer } from "@xmly-fem/web-jssdk";
import { mapState, mapActions, mapMutations } from "vuex";
import ScrollUser from "@/components/Use/scroll-user";
import ToastInfo from "@/components/Use/toast-info";
export default {
  data() {
    return {
      musicFlag: true,
      baseData: null,
      statusBarHeight: 0,
      thisPage: "home",
      show: false,
      formPage: "",
      path: "home",
      oContent: {},
      timeCount: 0,
      timer: null,
      cacheList: ["home"],
      isScroll_top: true,
      isScroll_bottom: false,
      isShouldRefresh: false,
    };
  },
  computed: {
    ...mapState([
      "isApp",
      "versionSize",
      "userinfo",
      "pageLoading",
      "shareData",
      "isImmerse",
      "maskData",
      "globalDuration",
      "isClearTimer",
      "toastContent",
      "isToastShow",
      "readNewsId",
      "isClearInitTimer",
      "maskShowStatus",
      "tourSelectData",
      "isUserShow",
      "xmly",
      "fakeUserList",
      "isAudioShow",
    ]),
    ...mapState("audio", [
      "xPlayer",
      "fPlayer",
      "audioCurrentIndex",
      "audioList",
    ]),
  },
  components: {
    SelectButton,
    ScenicSpot,
    NearbyPoint,
    NewsInfo,
    AudioInfo,
    XimalayaAudioInfo,
    ScrollUser,
    ToastInfo,
  },
  watch: {
    // globalDuration(value) {
    //     if (value == 0) {
    //         this.timeCount = 0;
    //         this.timer = setInterval(this.inter, 1000);
    //     }
    // },

    isClearTimer(value) {
      // console.info("isClearTimer开启页面定时刷新请求", value);
      //  clearInterval(this.timer);
      if (value) {
        clearInterval(this.timer);
      } else {
        this.timeCount = 0;
        this.timer = setInterval(this.inter, 1000);
      }
    },

    $route(to, from) {
      this.thisPage = to.name;
      this.formPage = from.name;
      let referrer = document.referrer;
      console.info("referrer", referrer);
      if (from.name == "blank" && to.name == "home") {
      }
      // if(referrer!==''&&from.name!=='blank'&&!this.isClearInitTimer){
      //     this.getInterData(0)
      // }
      if (this.formPage == null) {
        // this.$router.replace('/')
      }
      this.setPageLoadingAsync(true);
      // document.querySelector('.loading-wrap').style.display = 'block'

     
    },
  },

  created() {
    this.IsPC(document);
    getAudioAccess();
    this.setXmly(new XMLY());
      let _this=this
  getmicrophone(function(){
    // 麦克风授权允许
     _this.setPermitUseMicrophone(true)
     _this.setMicrophoneErrorData("")
  },function(errorName){
     // 麦克风授权不允许,错误名称
     console.log("error麦克风授权不允许",errorName)
     _this.setMicrophoneErrorData(errorName)
    _this.setPermitUseMicrophone(false)
  })
 
  
  },
  mounted() {
    let timestamp = new Date().getTime();
    this.setSessionId(timestamp);
    this.path = this.$route.name;
    this.appFlagAsync(COVERAPP.Attribute.isApp());
    // this.getInterData()
    let _this = this;
    let isFromSecondFloor = false;
    // cio.initLoad({activeId: "", applicationId: "coverzxrobot"});
    (function(para) {
      var p = para.sdkUrl,
        n = para.name,
        w = window,
        d = document,
        a = para.activeId,
        ap = para.applicationId,
        s = "script",
        x = null,
        y = null;
      w[n] =
        w[n] ||
        function(a) {
          return function() {
            (w[n]._q = w[n]._q || []).push([a, arguments]);
          };
        };
      if (!w[n]._t) {
        (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
        x.async = 1;
        x.src = p + "?aid=" + a + "&appid=" + ap;
        w[n].para = para;
        y.parentNode.insertBefore(x, y);
      }
    })({
      sdkUrl: "https://dcdn.thecover.cn/cio/cover-track-cio.js",
      name: "cio",
      activeId: "",
      applicationId: "coverzxrobot",
    });

    this.getUserInfoAsync();

    // !this.isApp && COVER.isWapHidden()

    if (this.isApp) {
      let version = COVERAPP.Attribute.appVersion();
      let versionNum = version.split(".");
      let versionSize = parseInt(versionNum.join(""));
      this.setVersionSizeAsync(versionSize);
      if (this.versionSize >= 570) {
        COVERAPP.Method.getWebInfo({
          callback(ret) {
            let data =
              typeof ret == "object".toLowerCase() ? JSON.stringify(ret) : ret;
            if (JSON.parse(data).showType == 1) {
              _this.setIsImmerseAsync(true);
              let statusBarHeight = JSON.parse(data).statusBarHeight;
              if (COVERAPP.Attribute.isAndroid()) {
                let devicePixelRatio =
                  (typeof window.devicePixelRatio).toLowerCase() == "number"
                    ? window.devicePixelRatio
                    : 0;
                _this.statusBarHeight = devicePixelRatio
                  ? statusBarHeight / devicePixelRatio
                  : statusBarHeight;
              } else {
                _this.statusBarHeight = statusBarHeight;
              }
            }
            if (JSON.parse(data).isFromSecondFloor == 1) {
              isFromSecondFloor = true;
              COVERAPP.Method.webContentLoadFinish();
            }
          },
        });
      }
    }
    // _this.onWatch();
    _this.setPageLoadingAsync(false);
    clearTimeout(timeoutIds);

    this.visible();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions([
      "setPageLoadingAsync",
      "setIsImmerseAsync",
      "appFlagAsync",
      "setVersionSizeAsync",
      "setMaskDataAsync",
      "getUserInfoAsync",
      "getHotTopic",
      "queryComment",
      "setNoInfo",
      "getTourData",
     
    ]),
    ...mapMutations([
      "setSessionId",
      "contactDisData",
      "setGlobalDuration",
      "setToastShow",
      "setClearTimer",
      "setInputBlur",
      "setTagsList",
      "setTourSelectData",
      "setSingleTags",
      "IsPC",
      "setXmly",
       "setPermitUseMicrophone",
       "setMicrophoneErrorData"
    ]),
  ...mapMutations("audio", [
      "setXPlayer",     
    ]),
    getInterData(time) {
      let that = this;
      this.initTimer = setTimeout(function() {
        that.setNoInfo();
      }, time);
    },
    onWatch() {
      let that = this;
      that.timeCount = 0;
      that.timer = setInterval(that.inter, 1000);
    },
    inter() {
      let that = this;
      window.addEventListener(
        "touchstart",
        function() {
          that.timeCount = 0;
          that.setGlobalDuration(0);
        },
        false
      );
      that.timeCount++;
      console.log(that.timeCount);
      if (that.timeCount > 10) {
        that.getHotTopic();
        clearInterval(that.timer);
        that.timeCount = 0;
        that.setGlobalDuration(11);
      }
    },
    onBack() {
      if (this.thisPage != "home") {
        this.$router.back(-1);
      } else {
        COVERAPP.Method.Back();
      }
    },
    musicPlay() {
      let _this = this;
      let music = document.getElementById("music");
      if (this.musicFlag) {
        music.play();
      }
      // 微信自动播放
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          if (this.musicFlag) {
            music.play();
          }
        },
        false
      );
      // 兼容其他不自动播放的情况
      document.addEventListener(
        "touchstart",
        () => {
          if (this.musicFlag && this.thisPage == "home") {
            music.play();
          }
        },
        false
      );
    },
    switchMusic(e) {
      let music = document.getElementById("music");
      this.musicFlag && e.stopPropagation();
      this.musicFlag = !this.musicFlag;
      if (this.musicFlag) {
        music.play();
      } else {
        music.pause();
      }
    },
    back() {
      if (this.formPage == null || this.thisPage != "home") {
        this.$router.back(-1);
      } else {
        COVERAPP.Method.Back();
      }
    },
    share() {
      let _this = this;
      let ShareData = JSON.parse(JSON.stringify(this.shareData));
      ShareData.callback = function(ret) {
        // COVER.track(_this.aid, 'share', '分享')
        cio.track(1, "share", {});
      };
      if (!this.isImmerse) {
        COVER.share(ShareData);
      }
    },
    onCloseToast() {
      const { toastType } = this.toastContent;

      if (toastType == 1 || toastType == 2) {
        this.getTourData({ payload: {} });
      }
      if (toastType === 7) {
        this.setClearTimer(true);
        this.contactDisData([{ content: { right: true, tips: "" } }]);
        this.queryComment({ payload: { newsId: this.readNewsId } });
      }
      if (toastType === 12) {
        this.setClearTimer(false);
      }
      this.setToastShow(false);
    },
    oTourSelect(name, value, id, type, child, select) {
      console.info("select", !!select);
      const { selectType } = this.toastContent;
      let array = [];
      if (selectType == "single") {
        this.tourSelectData.map((item, ix) => {
          if (item.name === name && !item.select) {
            item.select = true;
            array.push(item);
          } else {
            item.select = false;
            array.push(item);
          }
        });
        this.setSingleTags([{ name: name, value: value, select: !!select }]);
      } else {
        this.tourSelectData.map((item, ix) => {
          if (item.name === name && !item.select) {
            item.select = true;
            array.push(item);
          } else if (item.name === name && item.select) {
            item.select = false;
            array.push(item);
          } else {
            array.push(item);
          }
        });
        this.setTagsList([{ name: name, value: value, select: !!select }]);
      }

      this.setTourSelectData(array);
    },
    handleScroll(type) {
      this.isShouldRefresh = false;
      if (type === 9 || type === 10) {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = this.$refs.contentTips.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = this.$refs.contentTips.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = this.$refs.contentTips.scrollHeight;
        //滚动条到底部的条件
        if (scrollTop + windowHeight + 10 >= scrollHeight) {
          //到了这个就可以进行业务逻辑加载后台数据了
          console.log("到了底部");
          this.isShouldRefresh = true;
        }
      }
    },
    visible() {
      document.addEventListener("visibilitychange", () => {
        // if (document.hidden && this.isAudioShow) {
        //   console.log("熄屏熄屏");
        //   // this.xPlayer && this.xPlayer.play()
        // } else if (this.isAudioShow) {
        //   console.log("亮屏亮屏");
        //   // setTimeout(() => {
        //   console.log(this.audioList);
        //   let playList = [];
        //   this.audioList.forEach((item) => {
        //     playList.push(item.id);
        //   });
        //   this.setXPlayer(new XMplayer({ playlist: playList }));
        //   this.xPlayer && this.xPlayer.play();
        //   // }, 2000)
        // }
      });
    },
    onCancel(){
      this.setMaskDataAsync(null);
    },
     goSet(){
      this.setMaskDataAsync(null);
    }
  },
};
</script>

<style lang="less">
.maskWarp {
  /*position: fixed;*/
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0);
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.detailPop {
  font-size: 0.24rem;
  /*position: fixed;*/
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10005;
  /*display: none;*/

  .popWrapper {
    max-width: 100%;
    min-width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10001;
  }

  .popWrapper2 {
    max-width: 100%;
    min-width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10001;
    height: 80%;
  }

  .popGlobalText {
    color: rgba(100, 103, 114, 1);
    font-size: 0.4rem;
    line-height: 0.7rem;
    .emoji {
      width: 0.6rem;
      height: 0.6rem;
    }
  }

  .contentPopCls {
    padding: 1.3rem 0.4rem 1rem 0.4rem;
    border-radius: 0.5rem 0.5rem 0 0;
    position: relative;
    background: #fff;
    height: 100%;
    box-sizing: border-box;
  }

  .contentTips {
    font-size: 0.44rem;
    min-width: 6rem;
    line-height: 0.7rem;
    /*height: 100%;*/
    max-height: 11rem;
    overflow-y: scroll;
  }

  .contentTips2 {
    font-size: 0.44rem;
    min-width: 6rem;
    line-height: 0.7rem;
    height: 100%;
    overflow-y: scroll;
    border-radius: 0.5rem 0.5rem 0 0;
    .content {
      height: 100%;
    }
  }

  .topsOperate {
    height: 1.4rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 0 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;
    .popName {
      font-size: 0.45rem;
      color: #171e32;
    }
  }

  .close {
    .closeImg {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /*padding: 9.2rem 0 1rem;*/
  margin: 0 auto;
  background: #fff url("./assets/img/coverBg.jpg") no-repeat;
  background-size: 100%;
}

.back {
  position: fixed;
  bottom: 3.6rem;
  right: 0.2rem;
  z-index: 90;

  img {
    width: 1.4rem;
    height: 1.4rem;
  }
}

.has-top .wrapper {
  box-sizing: border-box;
}

.top {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 1.046699rem;
  z-index: 20;
}

.back-btn {
  width: 0.692432rem;
  height: 0.724638rem;
  position: absolute;
  top: 0.305958rem;
  left: 0.587762rem;
  background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261id2iomlg5of41lp62k.png)
    no-repeat center top;
  background-size: 100% auto;
  z-index: 10;
}

.share-btn {
  width: 0.68438rem;
  height: 0.716586rem;
  position: absolute;
  top: 0.305958rem;
  right: 0.386473rem;
  background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2717lf1elp1ff19un1b6k46.png)
    no-repeat center top;
  background-size: 100% auto;
  z-index: 10;
}

.music {
  position: fixed;
  top: 0;
  right: 1.545894rem;
  width: 0.716586rem;
  height: 1.1rem;
  z-index: 20;

  .music-btn {
    position: absolute;
    top: 0.305958rem;
    width: 100%;
    height: 0.764895rem;
    background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27d0vvl96571ej71l4949.png)
      no-repeat center top;
    background-size: 100% 200%;

    &.off {
      background-position: center bottom;
    }
  }
}

.scrollUser {
  width: 100%;
  height: 4.45rem;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
  /*position: fixed;*/
  position: absolute;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0rem -0.16rem 0.43rem 0rem #ecf6fe;
  border-radius: 0.96rem 0.96rem 0rem 0rem;
  z-index: 100;
  .topMask {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0 1rem 1rem #fff;
    border-radius: 0.96rem 0.96rem 0rem 0rem;
  }
  .bottomMask {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0 -1rem 1rem #fff;
    border-radius: 0.96rem 0.96rem 0rem 0rem;
  }
}

.loadMask {
  /*position: fixed;*/
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  .maskContent {
    background: #fff;
    display: inline-block;
    border-radius: 0.12rem;
    font-size: 0.45rem;
    padding: 0.2rem;
  }
  .SmallmaskContent{
    width: 80%;
    font-size: 0.4rem;
    .NotAllowedError{
      display: flex;
      flex-direction: column;
      .title{
          text-align: center;
    font-weight: 800;
    margin: 0.2rem auto;
      }
      .des{
        text-indent: .426667rem;
      }
    }
    .btn_wrapper{
       display: flex;
       justify-content: space-around;
      width: 100%;
      margin: 0.2rem auto;
      
     
    }
  }
}
</style>
